import { api } from "@/redux/api";

import {
	BulkChangeStatus,
	BulkChangeStatusResult,
	BulkChangeStatusResultSchema,
} from "../../pages/List/schema/bulk-change-status";
import {
	BulkBlacklist,
	BulkBlacklistResult,
	BulkBlacklistResultSchema,
} from "../../pages/List/schema/bulk-blacklist";

/**
 * The list table's bulk status move (extracted from `list.api.ts`, which re-exports the hook so its
 * callers are unchanged).
 *
 * Since PREC-2548 a move out of the blacklist goes through the same rules as the override modal:
 * an unsubscribe or a Signalist-wide entry keeps the lead there, and a company-wide entry is only
 * removed with `removeCompany`. The leads it kept come back named in `skippedFromBlacklist`.
 */
export const listBulkStatusApi = api.injectEndpoints({
	endpoints: (builder) => ({
		bulkChangeStatus: builder.mutation<BulkChangeStatusResult, BulkChangeStatus>({
			query: (body) => ({
				url: `list/bulkChangeStatus`,
				method: "PATCH",
				body,
				responseSchema: BulkChangeStatusResultSchema,
			}),
			invalidatesTags: (result, error, arg) => [{ type: "List", id: arg.listId }, "ListPerson"],
		}),
		/** Blacklists a selection on the server: every lead's entry, then one move (PREC-4435). */
		bulkBlacklist: builder.mutation<BulkBlacklistResult, BulkBlacklist>({
			query: (body) => ({
				url: `list/bulk-blacklist`,
				method: "POST",
				body,
				responseSchema: BulkBlacklistResultSchema,
			}),
			invalidatesTags: (result, error, arg) => [
				{ type: "List", id: arg.listId },
				"ListPerson",
				"Blacklist",
			],
		}),
	}),
});

export const { useBulkChangeStatusMutation, useBulkBlacklistMutation } = listBulkStatusApi;
